import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Gate for admin-only routes. Stacks inside <RequireAuth> so `loading` and
 * `isAuthorized` are already settled when this component renders. UX gate only
 * — the server re-enforces on every request.
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const { user, loading, isAuthorized, profile } = useAuth();

  const spinner = (label: string) => (
    <div className="flex min-h-screen items-center justify-center bg-paper-50 text-ink-500 dark:bg-clay-floor dark:text-paper-200">
      <span className="animate-pulse">{label}</span>
    </div>
  );

  if (loading) return spinner('Loading…');
  if (!user || isAuthorized !== true) return <Navigate to="/" replace />;
  if (profile?.role !== 'admin') return <Navigate to="/" replace />;
  return <>{children}</>;
}
